/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-10 15:21:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-03 14:58:36                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * WorkorderListItem: Display workorder list item
*/

/* Imports */
/***/

/* Components */
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../../../services/api/error";
/***/

import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import { api } from "../../../../../../services/api/api";
import WorkorderTypeForm from "../../../../../../components/data/workorder-type/WorkorderTypeForm";


/**
* WorkorderListItem: Display workorder list item
* @param workorder - Workorder data
* @param onClick - On click event
* @param isLast - Is last item
*/
export default function WorkorderTypesAdminActions({
  type,
  onChange
}: {
  type: EasyTech.WorkorderType,
  onChange: () => void
}) {
  /**
  * updateTechnician: update technician information
  * @param tech - technician data to update
  */
  const updateType = (type: EasyTech.WorkorderType): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (type.translations) {
        type.translations = type.translations.filter((el: EasyTech.Translation) => {
          const cond = !el.label;
          return !cond;
        });
      }
      if (type && type.label && type.id) {
        api.put("admin/workorder_types/"+type.id, type).then(() => {
          onChange();
          toast.success("Intervention types updated");
          return resolve();
        }).catch((error: any) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la mise à jour du type d'intervention" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  return(
    <div className="admin-wo-actions">
      <EditCreateDrawer data={(type as EasyTech.WorkorderType)}
        entityName="Intervention type"
        FormComponent={WorkorderTypeForm}
        isNotCreatable={true}
        onSubmit={updateType} />
    </div>
  );
}
/***/
